/* eslint-disable no-underscore-dangle */
import $ from 'jquery';
import SimpleBar from 'simplebar';
import Expandable from './expandable';
import Tabs from './tabs';
import NewsList from './news-list';
import ImageCredits from './image-credits';

// require('./esri-maps.js');

/* global x5script, initRiversMap */

class SalmonRivers {
  init() {
    this.riversBlock = $('.js-salmon-rivers');

    if (!this.riversBlock.length) {
      return;
    }

    this.Expandable = new Expandable();
    this.Tabs = new Tabs();
    this.NewsList = new NewsList();
    this.imageCredits = new ImageCredits();

    this.rivers = this.riversBlock.find('.js-bsrs-rivers');
    this.loaderHtml = x5script.loaderHtml;
    this.isLoading = false;

    this.riversList = this.rivers.find('.js-bsrs-rivers-list');
    this.riversDropdown = this.rivers.find('.js-bsrs-rivers-dropdown');
    this.riversListLinks = this.riversList.find('.js-c-bsrs-rivers-list-link');
    this.displayLoader = false;

    this.riveAdminBarNode = $('.js-ab-edit-river');

    this.riversListScrollbar();

    this.contentChange();
    this.contentChangeDropdown();
    this.contentInit();
    this.windowPopState();

    initRiversMap(
      this.riversList
        .find('.js-c-bsrs-rivers-list-link.is-active')
        .data('river'),
    );
  }

  windowPopState() {
    window.onpopstate = e => {
      if (e.state !== null && 'salmonRiver' in e.state) {
        const state = e.state.salmonRiver;

        this.windowHash = `#${state}`;
        this.initialLoad();
      }
    };
  }

  riversListScrollbar() {
    if (!this.riversList.length) {
      return;
    }

    this.simplebar = new SimpleBar(this.riversList[0], {
      autoHide: false,
    });
  }

  initialLoad() {
    if (this.windowHash) {
      const riverId = this.windowHash.replace(/^#/, '');
      let isInt = true;
      let activeRiver = this.riversList.find(
        `.js-c-bsrs-rivers-list-link[data-river-id="${riverId}"]`,
      );

      if (!activeRiver.length) {
        isInt = false;
        activeRiver = this.riversList.find(
          `.js-c-bsrs-rivers-list-link[data-river="${riverId}"]`,
        );
      }

      if (activeRiver.length) {
        const loadContent =
          (isInt && parseFloat(riverId) === parseFloat(this.riverId)) ||
          (!isInt && riverId === this.activeRiver);

        this.scrollToRiver = true;

        if (loadContent) {
          this.loadContent();
        } else {
          this.riverLink = activeRiver;
          this.changeContent();
        }
      } else {
        this.loadContent();
      }
    } else {
      this.loadContent();
    }
  }

  contentInit() {
    this.content = this.riversBlock.find('.js-bsrs-content');
    this.activeRiverButton = this.riversList.find('.is-active');
    this.activeRiver = this.activeRiverButton.data('river');
    this.riverId = this.activeRiverButton.data('river-id');
    this.blockId = this.riversBlock.attr('id');
    this.riverHeading = this.riversBlock.find('.js-river-heading');
    this.changeRiverBtn = this.riversBlock.find('.js-rivers-change-btn');

    this.windowHash = window.location.hash;

    this.initialLoad();
    this.scrollToRiver = false;

    this.changeRiver();
  }

  changeRiver() {
    this.changeRiverBtn.on('click', () => {
      $('body, html')
        .stop()
        .animate({
          scrollTop: this.riversList.offset().top - 130,
        });
    });
  }

  contentChangeDropdown() {
    this.riversDropdown.on('change', e => {
      const self = $(e.target);
      const value = self.val();

      const option = $('option:selected', e.target);

      self
        .find('option')
        .not(option)
        .removeAttr('selected');
      option.attr('selected', true);

      this.riverLink = this.riversList.find(
        `.js-c-bsrs-rivers-list-link[data-river=${value}]`,
      );

      this.scrollToRiver = true;
      this.changeContent();
    });
  }

  contentChange() {
    this.riversList.on('click', '.js-c-bsrs-rivers-list-link', e => {
      if (this.isLoading) {
        return;
      }

      const riverLink = $(e.currentTarget);

      // if (riverLink.hasClass('is-active')) {
      //   return;
      // }

      this.riverLink = riverLink;

      this.scrollToRiver = true;
      this.changeContent();
    });
  }

  changeContent() {
    this.riverId = this.riverLink.data('river-id');
    this.activeRiver = this.riverLink.data('river');

    const event = new CustomEvent('watershedSelected', {
      detail: { watershed: this.activeRiver.trim() },
      bubbles: true,
    });
    this.rivers[0].dispatchEvent(event);

    this.riversDropdown.val(this.activeRiver);

    this.riversListLinks
      .not(this.riverLink)
      .removeClass('is-active')
      .attr('aria-current', false);
    this.riverLink.addClass('is-active').attr('aria-current', true);
    this.riverHeading.text(this.riverLink.text());

    this.displayLoader = true;
    this.loadContent();
  }

  showLoader() {
    this.content.html(
      `<div class="c-bsrs-loader js-bsrs-loader">${this.loaderHtml}</div>`,
    );
  }

  populationRowsExpandable() {
    const expandBtn = this.content.find('.js-rpd-expand');

    expandBtn.on('click', e => {
      const self = $(e.currentTarget);
      const expandable = self.closest('.is-expandable');

      if (!expandable.length) {
        return;
      }

      const subrows = expandable.parent().next('.js-rpd-table-subrows');

      if (subrows.length) {
        subrows.slideToggle();
        self.toggleClass('is-open');
      }
    });
  }

  updateAdminBarEditLink(link) {
    if (this.riveAdminBarNode.length) {
      const aTag = this.riveAdminBarNode.find('a');
      aTag.attr('href', link);
      this.riveAdminBarNode.show();
    }
  }

  loadContent() {
    if (this.displayLoader) {
      this.showLoader();
    }

    if (this.riveAdminBarNode.length) {
      this.riveAdminBarNode.hide();
    }

    this.isLoading = true;

    const data = {
      action: 'load_salmon_river',
      river_id: this.riverId,
      block_id: this.blockId,
      security: x5script.security3,
    };

    $.post(x5script.ajaxurl, data, response => {
      if (response.ok) {
        const { html } = response;
        this.content
          .hide()
          .css({ opacity: 0 })
          .html(html);

        this.content.slideDown(200, () => {
          this.content.stop().animate({ opacity: 1 }, 300);
          this.Expandable.init();
          this.Tabs.init();
          this.NewsList.init();
          this.imageCredits.init();

          this.isLoading = false;
          this.Tabs.wwfInfoHeading();
          this.populationRowsExpandable();

          if (this.scrollToRiver) {
            this.scrollDown();
            this.scrollToRiver = false;
          }
        });

        this.updateAdminBarEditLink(response.riverEditUrl);

        if (
          window.history.state !== null &&
          'salmonRiver' in window.history.state
        ) {
          if (window.history.state.salmonRiver !== this.activeRiver) {
            window.history.pushState(
              { salmonRiver: this.activeRiver },
              document.title,
              `#${this.activeRiver}`,
            );
          }
        } else {
          window.history.replaceState(
            { salmonRiver: this.activeRiver },
            document.title,
            `#${this.activeRiver}`,
          );
        }
      } else {
        this.riversBlock
          .find('.js-loader')
          .parent()
          .after(
            `<p class="" style="color:#c00;margin-top:5px;text-align:center;">${
              response.error
            }</p>`,
          );
      }
    }).fail((xhr, status, error) => {
      this.riversBlock
        .find('.js-loader')
        .parent()
        .after(
          `<p class="" style="color:#c00;margin-top:5px;text-align:center;">${error}</p>`,
        );
    });
  }

  scrollDown() {
    if (this.riverHeading.length) {
      $('html, body')
        .stop()
        .animate(
          {
            // scrollTop: this.riverHeading.offset().top - 50,
            scrollTop:
              this.riverHeading.offset().top -
              $(window).height() +
              this.riverHeading.outerHeight() +
              100,
          },
          500,
        );
    }
  }
}

export default SalmonRivers;



// WEBPACK FOOTER //
// ./src/scripts/modules/salmon-rivers.js